// extracted by mini-css-extract-plugin
export default {"edgebutton":"style_edgebutton__v4geO","edgebuttonforeignobject":"style_edgebuttonforeignobject__yPuAR"};